import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import RoutesConfig from './routes';
import UnexpectedError from './resources/unexpected_error';
import { CircularProgress } from '@mui/material';
import ProtectedRoute from 'contexts/auth/protected_route';
import { AuthProvider } from 'contexts/auth/auth_context';
import { PermissionsProvider } from 'contexts/auth/permission_context';

const Root: React.FC = () => {
  const createProtectedRoute = ({ path, element: Element, ...args }: any) => (
    <Route
      key={path}
      path={path}
      element={<ProtectedRoute element={<Element />} />}
      {...args}
    />
  );

  const createPublicRoute = ({ path, element: Element, ...args }: any) => (
    <Route
      key={path}
      path={path}
      element={<Element />}
      {...args}
    />
  );

  const renderRoute = (routeConfig: any) => {
    return routeConfig.protectedRoute
      ? createProtectedRoute(routeConfig)
      : createPublicRoute(routeConfig);
  };

  return (
    <Suspense fallback={<CircularProgress />}>
      <ErrorBoundary FallbackComponent={UnexpectedError}>
        <AuthProvider>
          <PermissionsProvider>
            <Routes>
              {RoutesConfig.map(renderRoute)}
            </Routes>
          </PermissionsProvider>
        </AuthProvider>
      </ErrorBoundary>
    </Suspense>
  );
};

export default Root;
